<template>
  <div class="d-flex flex-1 h-100 overflow-hidden">
    <v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
      <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
        <div class="custom-icon-wrapper">
          <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
        </div>
        <v-toolbar-title class="size-16 dark-text">{{ $t('res_Title_ManageCounter')}}</v-toolbar-title>
      </v-toolbar>
      <div>
        <v-row>
            <v-col class="border-top flex-1 overflow-auto text-end" style="margin-right: 40px;">
            <v-btn  @click="addRefrenceCount" width="150px" color="primary">{{$t("res_ButtonText_Add")}}</v-btn>
          </v-col>
        </v-row>
      </div>
      <div class="d-flex flex-1 flex-column overflow-auto p-4" style="padding: 5px">
        <v-data-table :headers="headers" :items="displayedItems"  item-key="id" disable-sort hide-default-footer class="elevation-1"
            :items-per-page="displayedItems.length">
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.name }}</td>
              <td>{{ row.item.value }} </td>
              <td>{{ row.item.active }} </td>
              <td>{{ row.item.resetByYear }} </td>
              <td>{{ row.item.byPdf }} </td>
              <td>{{ row.item.categoryName }} </td>
              <td>{{ row.item.structureName }} </td>
              <td>{{ row.item.templateName }} </td>
              <td>{{ row.item.companyName }} </td>
              <td class="text-start">
                <div class="onhover-display">
                  <div class="custom-icon-wrapper">
                    <v-icon small @click="editRefernceCounterDialog(row.item)" v-tooltip="'Edit'">custom-icon white-bg edit-icon</v-icon>
                  </div>
                  <div class="custom-icon-wrapper">
                    <v-icon small @click="deleteRefernceCounter(row.item.id)" v-tooltip="'Delete'" >custom-icon white-bg delete-icon</v-icon>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-dialog v-model="openDialog" max-width="500px">
          <v-card>
            <v-card-title>{{action == 'add' ? $t('res_ButtonText_Add') : $t('res_ButtonText_Edit')}}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6"  >
                  <v-label>{{ $t("res_Label_SelectCategory") }} *</v-label>
                  <multi-select class="light-bg add-arrow" v-model=" editedItem.categoryId" label="name" track-by="id"
                  open-direction="bottom"  :options="category_items" :searchable="false" :loading="loading"
                  :internal-search="false" :clear-on-select="false" :close-on-select="true"
                  :options-limit="300" :max-height="1000" :show-no-results="false" :hide-selected="false"
                  :multiple="false" :disabled="this.action=='edit'" :placeholder="$t('res_Label_Select')">
                </multi-select>
              </v-col>
                <v-col cols="6"  >
                  <v-label>{{ $t("res_Label_SelectCompany") }} </v-label>
                  <multi-select class="light-bg add-arrow" v-model="editedItem.companyId" label="name" track-by="id"
                  open-direction="bottom" :options="company_items" :searchable="false" :loading="loading"
                  :internal-search="false" :disabled="this.action=='edit'" :clear-on-select="false" :close-on-select="true"
                  :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                  :multiple="false" :placeholder="$t('res_Label_Select')">
                </multi-select>
              </v-col>
            <v-col cols="6" >
              <v-label>{{ $t("res_Label_Structure") }} </v-label>
        <StructureUserSelector  :showInternalUsers="false" :showExternalUsers="false"
            :showInternalStructures="true"
            :showExternalStructures="false" 
            :isMultiple="false" :selectedStructureUser="editedItem.structureId"
            :disableOtherInternalEntitiesAsExternal="true" :disabled="this.action=='edit'"
            @structureUserSelectChanged="structureUserSelectChanged" :addressBook_header="$t('res_Label_SelectStrucutre')">
        </StructureUserSelector>

            </v-col>
            <v-col cols="6"  >
                <v-label>{{ $t("res_MenuItems_ChooseTemplate") }} </v-label>
                <multi-select class="light-bg add-arrow" v-model="editedItem.templateId" label="name" track-by="id"
                    open-direction="bottom" :options="templates_items" :searchable="false" :loading="loading"
                    :internal-search="false" :clear-on-select="false" :close-on-select="true"
                    :options-limit="300" :disabled="this.action=='edit'" :max-height="1000" :show-no-results="false" :hide-selected="false"
                    :multiple="false" :placeholder="$t('res_Label_Select')">
                </multi-select>
              </v-col>
                <v-col cols="6" >
                  <v-label>{{ $t("res_Label_Name") }}*</v-label>
                  <v-text-field  v-model="editedItem.name" label="" solo></v-text-field>
                </v-col>
                <v-col cols="6" >
                  <v-label>{{ $t("res_Label_Value") }}*</v-label>
                  <v-text-field type="number"  v-model="editedItem.value" label="" solo></v-text-field>
                </v-col>
                <v-col cols="4"  >
                  <v-checkbox v-model="editedItem.active"  :label="$t('res_CheckBox_Active')" solo></v-checkbox>
                </v-col>
                <v-col cols="4" >
                  <v-checkbox v-model="editedItem.resetByYear" :label="$t('res_CheckBox_ResetByYear')" solo></v-checkbox>
                </v-col>
                <v-col cols="4" >
                  <v-checkbox :disabled="this.action=='edit'" v-model="editedItem.byPdf"  :label="$t('res_CheckBox_ByPdf')" solo></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="gap-2 sticky-actions" v-bind="row">
              <v-btn class="primary" style="min-width: 100px !important;" @click="UpdateRefernceCounter()">{{action == 'add' ? $t('res_ButtonText_Add') : $t('res_ButtonText_Edit')}}</v-btn>
              <v-btn  class="light-blue" style="min-width: 100px !important;" @click="openDialog = false">{{ $t("res_ButtonText_Close") }}</v-btn>
            </v-card-actions>
          </v-card>               
        </v-dialog>
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import constants from "@/assets/js/constants.js";
import router from '../../router/index.js';
import MultiSelect from 'vue-multiselect';
import StructureUserSelector from '@/components/StructureUserSelector.vue';

export default {
  components: { MultiSelect,StructureUserSelector },
  data() {
    return {
      action: '',
      editedItem: {
        id: 0,
        name : "",
        value: null,
        active: false,
        resetByYear : false,
         structureId:{},
         companyId:{},
         templateId:{},
         categoryId :{},
         byPdf:false
      },
      openDialog: false,
      headers: [
        { text: this.$t("res_GridHeaders_Name"), value: "name", align: "start", width: "10%" },
        { text: this.$t("res_GridHeaders_Value"), value: "entityName", align: "start", width: "10%" },
        { text: this.$t("res_GridHeaders_Active"), value: "active", align: "start", width: "10%" },
        { text: this.$t("res_GridHeaders_ResetByYear"), value: "resetByYear", align: "start", width: "10%" },        
        { text: this.$t("res_GridHeaders_ByPdf"), value: "byPdf", align: "start", width: "10%" },
        { text: this.$t("res_Label_Category"), value: "categoryName", align: "start", width: "10%" },
        { text: this.$t("res_Label_Structure"), value: "structureName", align: "start", width: "10%" },
        { text: this.$t("res_Label_TemplateName"), value: "templateName", align: "start", width: "10%" },
        { text: this.$t("res_label_Company"), value: "companyName", align: "start", width: "10%" },
        { text: this.$t("res_GridHeaders_Actions"), value: "actions", align: "start", width: "10%" },

      ],
      displayedItems: [],
      company_items: [],
      templates_items:[],
      category_items:[],
      structure_items:[],

      loading: false,
    };
  },
  methods: {
    backToAdminPage() {
      router.push({ name: 'admin' });
    },
    getCompaniesForUser() {
      axios.get(constants.baseApiUrl + "Admin/GetCompaniesForUser")
        .then((res) => this.company_items = res.data)
        .catch((err) => console.warn(err))
    },
    getAllTemplates() {
      axios.get(constants.baseApiUrl + "Admin/GetAllTemplates")
        .then((res) => this.templates_items = res.data)
        .catch((err) => console.warn(err))
        
    },
    async getAllCategory() {
      try {
        const response = await axios.get(
          constants.baseApiUrl + "Admin/GetAllCategory"
        );
        const responseData = response.data;
        for (let i = 0; i < responseData.length; i++) {
          const category = {
            id: responseData[i].id,
            name: responseData[i].name,
          };
          this.category_items.push(category);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    
    structureUserSelectChanged(item) {
            this.editedItem.structureId = item;
        },

    editRefernceCounterDialog(item) {
      this.editedItem = { 
        id: item.id,
        active : item.active,
        resetByYear : item.resetByYear,
        byPdf : item.byPdf,
        name :item.name,
        value : item.value,
        categoryId: this.category_items.find(x=>x.id==item.categoryId),
        templateId: this.templates_items.find(x=>x.id==item.templateId),
        companyId: this.company_items.find(x=>x.id==item.companyId),
        structureId : item.structures
      }; 
      this.openDialog = true; 
      this.action = 'edit';
    },
    resetDataForm() {
      this.editedItem.name = null;
      this.editedItem.active = false;
      this.editedItem.value = null;
      this.editedItem.resetByYear = false;
      this.editedItem.byPdf = false;
      this.editedItem.categoryId=null;
      this.editedItem.structureId=null;
      this.editedItem.companyId=null;
      this.editedItem.templateId=null;
    },
    addRefrenceCount() {
      this.openDialog = true;
      this.action = 'add';
      this.resetDataForm();
    },
    addNewItem(){
     
     if(this.editedItem.categoryId == null|| this.editedItem.value==null  ||this.editedItem.name==null)
    {
     return window.showAlert('res_Msgs_FillRequired', 'error');
    }
      this.editedItem.structureId = this.editedItem.structureId?this.editedItem.structureId.id: this.editedItem.structureId = null;
      this.editedItem.companyId = this.editedItem.companyId?this.editedItem.companyId.id: this.editedItem.companyId = null;
      this.editedItem.templateId= this.editedItem.templateId? this.editedItem.templateId.id: this.editedItem.templateId = null;
      this.editedItem.categoryId =this.editedItem.categoryId.id
      window.showLoading()
      axios.post(constants.baseApiUrl + 'Admin/AddReferenceCounter' , this.editedItem )
        .then((res) => {
          if (res == undefined || res.data == null )
            window.showAlert('res_Msgs_ErrorOccured', 'error');
          else {
            window.showAlert('res_Msgs_AddRefernceCounter', 'success');
            this.fetchData();
            this.openDialog=false;
            this.resetDataForm();
          }
        })
        .catch(err => {
          this.handleError(err);
          window.hideLoading();
        })
        .finally(() => window.hideLoading());
    },
    async fetchData() {
      window.showLoading()
      const res = await axios
        .get(constants.baseApiUrl + "Admin/GetReferenceCounter")
        .then((res) => {
          this.displayedItems = res.data;
        })
        .catch((error) => console.error("Error fetching data:", error)).
        finally(() => window.hideLoading());
    },
    UpdateRefernceCounter() {
      var editNewReference = {
        Active: this.editedItem.active,
        ResetByYear: this.editedItem.resetByYear,
        ByPdf :this.editedItem.byPdf,
        Name : this.editedItem.name,
        Value : this.editedItem.value
      };
      if(this.action == 'edit'){
        window.showLoading()  
        axios.put(constants.baseApiUrl + 'Admin/UpdateReferenceCounters/' + this.editedItem.id, editNewReference,{ headers: constants.headers })
        .then((res) => {
          if (res == undefined || res.data == null) {
            window.showAlert('res_Msgs_ErrorOccured', 'error');
          } else {
            window.showAlert('res_Msgs_RefernceCountUpdated', 'success');
            this.fetchData();
            this.openDialog = false;
            this.resetDataForm();
          }
        })
        .catch(err => {
          this.handleError(err);
          window.hideLoading();
        })
        .finally(() => window.hideLoading());
      } else if(this.action == 'add') {
        this.addNewItem(); 
      }
    },
    deleteRefernceCounter(id) {
      window.showInformation('Confirmation', ('res_Msgs_CategoryRefernceDeleteConfirmation'),
        () => {
          window.showLoading()
          axios.delete(constants.baseApiUrl + 'Admin/DeleteReferenceCounter/' + id)
            .then((res) => {
              window.showAlert('res_Msgs_RefernceCountDeleted' ,'success');
              this.fetchData();
            })
            .catch((err) => {
              console.log(err);
            }).
            finally(() => window.hideLoading());
        },
        () => {}
      );
    },
  },
  mounted() {
    this.fetchData();
    this.getCompaniesForUser();
    this.getAllTemplates();
    this.getAllCategory();
  }
}
</script>

<style scoped>
.v-card__title { align-items: normal; }
.margin-left {
  margin-left: 25px;
}
</style>
